var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 195,
    viewBox: "0 0 248 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 195,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.625 72.5H142.25V69.375C142.25 67.6562 140.844 66.25 139.125 66.25H107.875C106.156 66.25 104.75 67.6562 104.75 69.375V72.5H95.375C93.6562 72.5 92.25 73.9062 92.25 75.625V85C92.25 98.4062 97.8437 106.5 107.281 106.844C108.658 109.234 110.545 111.292 112.809 112.869C115.072 114.446 117.656 115.505 120.375 115.969V122.5H111V128.75H136V122.5H126.625V115.969C129.346 115.509 131.931 114.452 134.195 112.874C136.459 111.297 138.345 109.237 139.719 106.844C149.125 106.5 154.75 98.4062 154.75 85V75.625C154.75 73.9062 153.344 72.5 151.625 72.5ZM98.5 85V78.75H104.75V97.5C104.75 98.375 104.844 99.25 104.937 100.094C99.1875 97.875 98.5 89.0937 98.5 85ZM136 97.5C136 104.406 130.406 110 123.5 110C116.594 110 111 104.406 111 97.5V72.5H136V97.5ZM148.5 85C148.5 89.0937 147.813 97.875 142.063 100.094C142.188 99.25 142.25 98.375 142.25 97.5V78.75H148.5V85Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecords);
export default __webpack_public_path__ + "static/media/records.1d1d8e505b6f5f628efd2144c571adb9.svg";
export { ForwardRef as ReactComponent };